import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;

  @media (max-width: 424px) {
    height: auto;
  }

  @media (min-height: 900px) {
    height: calc(100vh - 542px);
  }

  a {
    padding: 8px 16px;
  }
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-size: 3.2rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver80};
    line-height: 1.2;
    margin-bottom: 28px;

    > strong {
      color: ${theme.colors.brandPrimary70};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: 2.4rem;
    font-weight: 600;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.2;
    margin-bottom: 24px;
  `}
`;

export const Text = styled.p`
  ${({ theme }) => css`
    font-size: 2rem;
    color: ${theme.colors.neutralSilver70};
    line-height: 1.4;
    margin-bottom: 24px;

    > strong {
      font-weight: 600;
    }
  `}
`;
